import React from 'react'
import { Form } from 'react-bootstrap'
import { VideoType } from '../types'

interface VideoTypeSelectProps {
    videoType: VideoType
    setVideoType: (type: VideoType) => void
}

const VideoTypeSelect = ({ videoType, setVideoType }: VideoTypeSelectProps) => (
    <>
        <Form.Check
            inline
            value={VideoType.link}
            checked={videoType === VideoType.link}
            onChange={() => setVideoType(VideoType.link)}
            label="Link"
            type="radio"
            id="select-type"
        />
        <Form.Check
            inline
            value={VideoType.upload}
            checked={videoType === VideoType.upload}
            onChange={() => setVideoType(VideoType.upload)}
            label="Upload"
            type="radio"
            id="select-type"
        />
    </>
)

export default VideoTypeSelect
